import { render, staticRenderFns } from "./IconSvgNYSSCPAMentormatch.vue?vue&type=template&id=002be0e7&scoped=true&"
import script from "./IconSvgNYSSCPAMentormatch.vue?vue&type=script&lang=js&"
export * from "./IconSvgNYSSCPAMentormatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002be0e7",
  null
  
)

export default component.exports